import { createDocument, getAllData } from "apis/customApiHandler";
import Spinner from "components/Spinner";
import { Select } from "styled";
import axios from 'apis/axios'
import { Fragment, useCallback, useState } from "react";
import { BiCloudDownload } from "react-icons/bi";
import { useQuery } from "react-query";
import ReactSelect from "react-select";
import { TD, TH } from "styled/table";
import exportExcel from "utils/exportExcel";
import Modal from "components/Modal";
import {Button} from 'styled'
import toast from 'react-hot-toast';

const contractTypeOptions = [
  { value: 'All', label: 'All' },
  { value: 'CPKM', label: 'CPKM' },
  { value: 'NON CPKM', label: 'NON CPKM' }
];


const AlignmentPending = () => {
  const [selectedFleets, setSelectedFleets] = useState([]);
  const [selectedHubs, setSelectedHubs] = useState([]);
  const [data, setData] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [fleetMap, setFleetMap] = useState({});
  const [downloading, setDownloading ] = useState(false)
  const [contractType, setContractType] = useState("All");
  const [reportData, setReportData] = useState({})
  const [reportType, setReportType] = useState("fleet");
  const [appliedReportType, setAppliedReportType] = useState("fleet");
  const getData = async ()=>{
    setIsLoading(true)
    try{
    const dt = await  createDocument("/report/alignmentPending", {
      ...(selectedFleets?.includes("all")
      ? {
        fleets: getFleetOptions().filter(item => item.value!== "all" && item.value!== "clear")
        .map((item) => item.value)
            .join(","),
        }
      : selectedFleets.length && {
          fleets: selectedFleets.map((fleet) => fleet).join(","),
        }),
    ...(selectedHubs?.includes("all")
      ? {
          hubs: getHubOptions().filter(item => item.value!== "all" && item.value!== "clear")
            .map((item) => item.value)
            .join(","),
        }
      : selectedHubs.length && {
          hubs: selectedHubs.map((hub) => hub).join(","),
        }),
  ...(contractType && contractType!== "All" &&  {
        contractType: contractType
      }),
  reportType,
    })

    setData(dt);
    setAppliedReportType(reportType);
  }catch(err){

  }finally{
    setIsLoading(false)
  }

  }
  const getDownloadData = async ()=>{
    setDownloading(true)
    try{
      const dt = await createDocument("/report/alignmentPending", {
        ...(selectedFleets?.includes("all")
          ? {
            fleets: getFleetOptions().filter(item => item.value!== "all" && item.value!== "clear")
            .map((item) => item.value)
                .join(","),
            }
          : selectedFleets.length && {
              fleets: selectedFleets.map((fleet) => fleet).join(","),
            }),
        ...(selectedHubs?.includes("all")
          ? {
            hubs: getHubOptions().filter(item => item.value!== "all" && item.value!== "clear")
            .map((item) => item.value)
                .join(","),
            }
          : selectedHubs.length && {
              hubs: selectedHubs.map((hub) => hub).join(","),
            }),
        ...(contractType &&
          contractType !== "All" && {
            contractType: contractType,
          }),
        reportType,
      });

    if(dt.data){
      let exportData = dt?.data?.map((x, idx) => ({
        "Fleet Name":  `${x[1].fleetName} (${x[1].fleetCity})`,
        ...(reportType === "hub" && { "Hub Name": x[1].hubName ?? "N/A" }),
        "Fleet Code": x[1].fleetCode ?? x[0],
        "Total": x[1].total ?? 0,
        "CPKM": x[1].CPKM?.length ?? 0,
        "Service": x[1].Service?.length ?? 0,
        "0-20K": x[1].zeroTo20 ?? 0,
        "20-40K": x[1].twentyTo40 ?? 0,
        "40-60K": x[1].fortyTo60 ?? 0,
        ">60K": x[1].above60 ?? 0,
      }))

      exportData.push({
        "Total": dt.totalRow?.total ?? 0,
        "CPKM": dt.totalRow?.totalCPKM,
        "Service": dt.totalRow?.totalService ?? 0,
        "0-20K": dt.totalRow?.totalZeroTo20 ?? 0,
        "20-40K": dt.totalRow?.totalTwentyTo40 ?? 0,
        "40-60K":dt.totalRow?.totalFortyTo60 ?? 0,
        ">60K": dt.totalRow?.totalAbove60 ?? 0,
      })

      exportExcel(exportData, "alignmentPending", true)
    }
    }catch(err){

    }
    finally{ setDownloading(false) }  

  }

  const { data: allFleets } = useQuery([`/customer-fleet`], () =>
    getAllData("/customer-fleet", {
      limit: 3000,
    })
  );
  const { data: allHubs } = useQuery([`/customer-hub`], () =>
    getAllData("/customer-hub", {
      limit: 3000,
    })
  );

  const getFleetOptions = useCallback(() => {
    if (allFleets && allFleets.data && allFleets.data.length) {
      return [
        {
          label: "All",
          value: "all",
        },
        {
          label: "Clear",
          value: "clear",
        },
        ...allFleets?.data?.map((fleet) => {
          return {
            value: fleet._id,
            label: fleet.fleetName,
          };
        }),
      ];
    }
  }, [allFleets]);

  const getHubOptions = useCallback(() => {
    if (allHubs && allHubs.data && allHubs.data.length) {
      return [
       ...selectedFleets?.length ? [{
          label: "All",
          value: "all",
        }]: [],
        ...selectedFleets?.length ? [{
          label: "Clear",
          value: "clear",
        }]: [],
        ...(selectedFleets?.includes("all") ? 
        allHubs?.data?.length &&
          allHubs?.data
            ?.map((hub) => {
              return {
                value: hub._id,
                label: hub.hubName,
              };
            }) : 
        allHubs?.data?.length &&
          allHubs?.data
            ?.filter((hub) => {
              const selectedFleetsVal = allFleets?.data?.filter((fleet) =>
                selectedFleets?.includes(fleet._id)
              );

              return selectedFleetsVal?.some(
                (fleet) => fleet.fleetCode === hub.fleetCode
              );
            })
            ?.map((hub) => {
              return {
                value: hub._id,
                label: hub.hubName,
              };
            })),
      ];
    }
  }, [allFleets, allHubs, selectedFleets]);

  return (
    <div>
      <div className="w-full px-8 flex justify-center items-center mt-4 gap-4">
        <label className="w-full ">
          Select Fleets
          <ReactSelect
          
            styles={{
              control: (base, state) => ({
                ...base,
                borderColor: "transparent",
                minWidth: "100%",
                "&:hover": {
                  borderColor: "rgb(34 197 94)",
                },
              }),
            }}
            className="shadow-md rounded-md py-1 "
            options={getFleetOptions()}
            value={
              selectedFleets &&
              selectedFleets?.map((fleet) => {
                return {
                  value: fleet,
                  label: getFleetOptions()?.find((item) => item?.value === fleet)
                    ?.label,
                };
              })
            }
            onChange={(value) => {
              let allValues = value?.map((item) => item.value);
              if(allValues?.includes("clear")){
                setSelectedFleets([]);
                setSelectedHubs([]);
                return;
              }
              if(!selectedFleets?.includes("all") && allValues.includes("all")){
                setSelectedFleets(["all"]);
                return;
              }

              if (selectedFleets.includes("all")) {
                value = value.filter(item => item.value!== "all")
              }

              let selectedFleetsVal = allFleets?.data?.filter((fleet) =>
                value?.map((item) => item.value)?.includes(fleet._id)
              );

              let selectedHubsVal = allHubs?.data?.filter((hub) =>
                selectedHubs?.map((item) => item)?.includes(hub._id)
              );
              
              setSelectedHubs(
                selectedHubsVal
                  ?.filter((hub) =>
                    selectedFleetsVal?.find(
                      (fleet) => fleet.fleetCode === hub.fleetCode
                    )
                  )
                  .map((hub) => hub._id)
              );

              setSelectedFleets(value.map((fleet) => fleet.value));
            }
          }
            name="fleets"
            isMulti = {true}
            // isMulti={selectedFleets?.includes("all") ? false : true}
            // isDisabled={selectedFleets?.includes("all") ? true : false}
          />
        </label>

        <label className="w-full ">
          Select Hubs
          <ReactSelect
            styles={{
              control: (base, state) => ({
                ...base,
                borderColor: "transparent",
                minWidth: "100%",
                "&:hover": {
                  borderColor: "rgb(34 197 94)",
                },
              }),
            }}
            className="shadow-md rounded-md py-1 "
            options={getHubOptions()}
            value={
              selectedHubs &&
              selectedHubs?.map((hub) => ({
                value: hub,
                label: getHubOptions()?.find((item) => item.value === hub)
                  ?.label,
              }))
            }
            onChange={(value) => {
              const allValues = value?.map((item) => item.value);
              if(allValues.includes("clear")){
                setSelectedHubs([])
                return;
              }
              if (!selectedHubs?.includes("all") && allValues.includes("all")) {
                let selectedFleetCodes = allFleets?.data?.filter((fleet) =>
                  selectedFleets?.includes(fleet._id)
                )?.map(fleet=>fleet.fleetCode);

                const selectedHubsData = allHubs?.data?.filter(hub=> selectedFleetCodes?.includes(hub.fleetCode))

                const mp = fleetMap;
                selectedHubsData.map(hub=>{
                  if(selectedFleetCodes?.includes(hub.fleetCode)){
                  if(mp[hub.fleetCode] === undefined) mp[hub.fleetCode] = [];
                  mp[hub.fleetCode] = [...mp[hub.fleetCode], hub._id]
                }})

                setFleetMap(mp);
                setSelectedHubs(["all"])
              } 
              else {
                value = value.filter(v => v.value !== "all")
                let selectedFleetCodes = allFleets?.data?.filter((fleet) =>
                  selectedFleets?.includes(fleet._id)
                )?.map(fleet=>fleet.fleetCode);

                const selectedHubsData = allHubs?.data?.filter(hub=> allValues?.includes(hub._id))
                // setFleetMap({});
                const mp = {};
                selectedHubsData.map(hub=>{
                  mp[hub.fleetCode] = [];
                })

                selectedHubsData.map(hub=>{
                  if(selectedFleetCodes?.includes(hub.fleetCode)){
                  if(mp[hub.fleetCode] === undefined) mp[hub.fleetCode] = [];
                  mp[hub.fleetCode] = [...mp[hub.fleetCode], hub._id]
                }})

                setFleetMap(mp);
                setSelectedHubs(value.map((hub) => hub.value));
              }
            }}
            name="hubs"
            isMulti={true}
          />
        </label>

        
        <label className="w-full">
            Contract Type
            <ReactSelect
           styles={{
            control: (base, state) => ({
              ...base,
              borderColor: 'transparent',
              minWidth: '100%',
              '&:hover': {
                borderColor: 'rgb(34 197 94)',
              },
            }),
          }}
            name="contractType"
            className="shadow-md rounded-md py-1 mb-2"
            value={contractTypeOptions.find(option => option.value === contractType)} // Find the option object based on the value
            onChange={(option) => {
              setContractType(option.value); // Store only the value
            }}
            options={contractTypeOptions}
          />
          </label>

        <label className="w-full">
          Report Type
          <Select
            value={reportType}
            onChange={(e) => setReportType(e.target.value)}
          >
            <option value="fleet">Fleet Wise</option>
            <option value="hub">Hub Wise</option>
          </Select>
        </label>

        <Button className='mt-5' type="button" disabled={!selectedFleets?.length} bgPrimary onClick={()=>getData()} >
            Search
          </Button>
        {downloading ? 'Downloading...' : selectedFleets?.length !== 0 && <BiCloudDownload
          className="w-32 h-32 mt-5 text-green-500 hover:scale-105 cursor-pointer text-center"
          onClick={() => {
            getDownloadData()
          }}
        />}
      </div>
      {isLoading ? (
        <Spinner />
      ) : (
        <div className="flex flex-col m-2 lg:m-10">
          <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
              <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <TH scope="col">S.N.</TH>
                      <TH scope="col">Fleet Name</TH>
                      {appliedReportType === "hub" && <TH scope="col">Hub Name</TH>}
                      <TH scope="col">Fleet Code</TH>
                      <TH scope="col">Total</TH>
                      <TH scope="col">CPKM</TH>
                      <TH scope="col">Service</TH>
                      <TH scope="col">0 - 20K</TH>
                      <TH scope="col">20 - 40K</TH>
                      <TH scope="col">40 - 60K</TH>
                      <TH scope="col">{">60K"}</TH>
                      {/* <TH scope="col">Total Tyres</TH> */}
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {data && data.data && 
                      data.data?.map((entry, idx) => {
                        const fleetCode = entry[1]?.fleetCode ?? entry[0];
                        const fleetId = allFleets?.data?.find(fleet => fleet.fleetCode === fleetCode)?._id;
                        const fleetsParam = selectedFleets?.includes("all")
                          ? getFleetOptions().filter(item => item.value !== "all" && item.value !== "clear")
                              .map((item) => item.value)
                              .join(",")
                          : selectedFleets.length
                            ? selectedFleets.map((fleet) => fleet).join(",")
                            : undefined;
                        const hubsParam = selectedHubs?.includes("all")
                          ? getHubOptions().filter(item => item.value !== "all" && item.value !== "clear")
                              .map((item) => item.value)
                              .join(",")
                          : selectedHubs.length
                            ? selectedHubs.map((hub) => hub).join(",")
                            : undefined;
                        return <ViewList 
                          fleetName={entry[1].fleetName} 
                          fleetCode={fleetCode}
                          fleetId={fleetId}
                          data={entry[1]} 
                          idx={idx}  
                          fleetCity={entry[1].fleetCity}
                          fleets={fleetsParam}
                          hubs={hubsParam}
                          contractType={contractType}
                          reportType={appliedReportType}
                          hubName={entry[1].hubName}
                          hubId={entry[1].hubId}
                        />
                    })}
                  </tbody>
                    {data?.totalRow ? <tfoot>
                      <tr className="text-gray-600 font-semibold bg-green-100">
                        <TD></TD>
                        <TD colSpan={appliedReportType === "hub" ? 3 : 2} className="text-left">
                          TOTAL
                        </TD>
                        <TD className="text-center">
                          {data?.totalRow?.total}
                        </TD>
                        <TD className="text-center">
                          {data?.totalRow?.totalCPKM}
                        </TD>
                        <TD className="text-center">
                          {data?.totalRow?.totalService}
                        </TD>
                        <TD className="text-center">
                          {data?.totalRow?.totalZeroTo20}
                        </TD>
                        <TD className="text-center">
                          {data?.totalRow?.totalTwentyTo40}
                        </TD>
                        <TD className="text-center">
                          {data?.totalRow?.totalFortyTo60}
                        </TD>
                        <TD className="text-center">
                          {data?.totalRow?.totalAbove60}
                        </TD>
                      </tr>
                    </tfoot> : <></>}
                </table>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AlignmentPending;

const ViewList = ({ fleetName, fleetCode, fleetId, data, idx, fleetCity, fleets, hubs, contractType, reportType = "fleet", hubName, hubId }) => {
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState({ title: "", data: [] });
  const [modalLoading, setModalLoading] = useState(false);

  const modalHandler = useCallback(
    async (title, category) => {
      if (!category || !fleetId) {
        setShowModal(false);
        setModalData({ title: "", data: [] });
        return;
      }
      setModalLoading(true);
      setShowModal(true);
      setModalData({ title, data: [] });
      try {
        const res = await createDocument(
          "/report/alignmentPending/modalInfo",
          {
            fleetId: fleetId,
            category,
            ...(reportType === "hub" && hubId && { hubId }),
            ...(reportType !== "hub" && fleets && { fleets }),
            ...(reportType !== "hub" && hubs && { hubs }),
            ...(contractType && contractType !== "All" && {
              contractType: contractType
            })
          }
        );
        setModalData({ title, data: res?.data ?? [] });
      } catch (err) {
        setModalData({ title, data: [] });
      } finally {
        setModalLoading(false);
      }
    },
    [fleetId, fleets, hubs, contractType, reportType, hubId]
  );

  const closeModal = useCallback(() => {
    setShowModal(false);
    setModalData({ title: "", data: [] });
  }, []);

  const downloadDiv = (fleetName, count, title) => {
    const countValue = Array.isArray(count) ? count.length : (count ?? 0);
    return countValue !== undefined && countValue !== null && <div className="flex gap-2 items-center justify-center">
      <span
        className="hover:text-green-500 cursor-pointer"
        onClick={() => {
          const fullFleetName = `${fleetName} (${fleetCity})`;
          modalHandler(`${fullFleetName} Alignment Details ${title}`, title);
        }}
      >
        {countValue}
      </span>
    </div>
  }
  
  return (
    <Fragment>
      {showModal && (
        <Modal
          handleClick={closeModal}
          title={modalData.title || "Alignment Details"}
          className="max-w-2xl"
        >
          <h1 className="w-full flex justify-end text-end px-2 my-1">
            {modalData?.data?.length > 0 && (
              <Button
                onClick={() => {
                  exportExcel(
                    modalData?.data?.map((item) => ({
                      "Fleet Name": `${fleetName} (${fleetCity})`,
                      "Fleet Code": fleetCode,
                      "Registration Number": item.registrationNumber,
                      "Contract Type": item.contractType,
                      "Last Alignment Date": item.lastAlignmentDate ? item.lastAlignmentDate : null,
                      "Last Alignment At": item.lastAlignmentHub,
                      "Last Alignment By": item.lastAlignmentBy,
                      "Run KM": item.killometerTravelled
                    })),
                    modalData.title.split(" ").join("_") + "_Data"
                  );
                }}
                className=" text-blue-500 hover:scale-105 cursor-pointer text-right"
              >
                Download
              </Button>
            )}
          </h1>
          {modalLoading ? (
            <div className="flex justify-center items-center p-8">
              <Spinner />
            </div>
          ) : (
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <TH scope="col">S.N.</TH>
                  <TH scope="col">Vehicle Number</TH>
                  <TH scope="col">Contract Type</TH>
                  <TH scope="col">Last Alignment By</TH>
                  <TH scope="col">Last Alignment At</TH>
                  <TH scope="col">Last Alignment On</TH>
                  <TH scope="col">Run KM</TH>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {modalData &&
                  modalData?.data?.length > 0 &&
                  modalData?.data?.map((vehicle, index) => (
                    <tr key={index}>
                      <TD>{index + 1}</TD>
                      <TD>{vehicle.registrationNumber}</TD>
                      <TD>{vehicle.contractType}</TD>
                      <TD>{vehicle.lastAlignmentBy}</TD>
                      <TD>{vehicle.lastAlignmentHub}</TD>
                      <TD>{vehicle.lastAlignmentDate}</TD>
                      <TD>{vehicle.killometerTravelled}</TD>
                    </tr>
                  ))}
                {(!modalData?.data || modalData?.data?.length === 0) && (
                  <tr>
                    <TD colSpan={7} className="text-center py-4">
                      No data available
                    </TD>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </Modal>
      )}
      <tr className={`${idx % 2 !== 0 && "bg-gray-100"}`}>
        <TD>{idx + 1}</TD>
        <TD>{`${fleetName} (${fleetCity})`}</TD>
        {reportType === "hub" && <TD>{hubName ?? "N/A"}</TD>}
        <TD>{fleetCode}</TD>
        {/* <TD>{data?.status}</TD> */}
        {/* itm scrap onwheel casing repair reuse retread */}
        <TD>
          { downloadDiv(fleetName, data?.total, 'Total') }
        </TD>
        <TD>
          { downloadDiv(fleetName, Array.isArray(data?.CPKM) ? data?.CPKM?.length : data?.CPKM, "CPKM") }
        </TD>
        <TD>
          { downloadDiv(fleetName, Array.isArray(data?.Service) ? data?.Service?.length : data?.Service, "Service") }
        </TD>
        <TD>
          { downloadDiv(fleetName, data?.zeroTo20, "0-20") }
        </TD>
        <TD>
          { downloadDiv(fleetName, data?.twentyTo40, '20-40') }
        </TD>
        <TD>
          { downloadDiv(fleetName, data?.fortyTo60, '40-60') }
        </TD>
        <TD>
          { downloadDiv(fleetName, data?.above60, 'Above 60') }
        </TD>
        

        {/* <TD>
          
        </TD> */}
      </tr>
    </Fragment>
  );
};
